import type { ManufacturerPaymentTerms } from './payment-terms-panel'

function plainNumber(value: string | number | null | undefined): string {
  if (value == null || value === '') return '?'
  const parsed = Number(value)
  return Number.isFinite(parsed) ? String(parsed) : String(value)
}

/** Plain wording, matching the backend's describe_terms ("1% 15, Net 30"). */
export function describePaymentTerms(terms: ManufacturerPaymentTerms): string {
  let balance: string
  switch (terms.payment_terms_type) {
    case null:
    case undefined:
    case '':
      return 'Not recorded'
    case 'discount_net':
      balance = `${plainNumber(terms.payment_terms_discount_percent)}% ${terms.payment_terms_discount_days ?? '?'}, Net ${terms.payment_terms_net_days ?? '?'}`
      break
    case 'net':
      balance = `Net ${terms.payment_terms_net_days ?? '?'}`
      break
    case 'proximo':
      balance = `Net ${terms.payment_terms_proximo_day ?? 10}th Prox`
      break
    case 'prepaid':
      balance = 'Prepaid'
      break
    case 'due_on_receipt':
      balance = 'Due on receipt'
      break
    default:
      balance = 'Unknown'
  }
  if (terms.payment_terms_deposit_percent != null && terms.payment_terms_deposit_percent !== '') {
    const rest = balance.startsWith('Net') ? balance : balance.toLowerCase()
    return `${plainNumber(terms.payment_terms_deposit_percent)}% deposit, then ${rest}`
  }
  return balance
}
